/**
 * FRTone — свет и тон КОЖИ поверх снятия блика.
 *
 * Зачем отдельно от `deshine` и `smoothSkin`. Те два решают физическую задачу:
 * убрать отражение источника и выровнять пятна тона. Но у говорящей головы
 * есть ещё два дефекта, которые физикой блика не описываются и которых нет ни
 * в одном браузерном конкуренте:
 *
 *   · лицо ТЕМНЕЕ кадра — вебкамера против окна, лампа за спиной, свет сверху
 *     (на записи созвона это самая частая жалоба вообще);
 *   · лицо ЗЕЛЕНИТ или СИНИТ — офисные лампы и мониторная подсветка красят
 *     кожу, а фон при этом выглядит нормально, и глобальный баланс белого
 *     чинить нечего.
 *
 * Оба лечатся ТОЛЬКО в области кожи (маска у нас уже есть) — иначе поднимая
 * лицо, поднимаешь и пересвеченное окно за ним.
 *
 * Две вещи, которые сделаны намеренно:
 *
 * 1. СВЕТ — мягкая передача `g·x / (1 + (g−1)·x)`, а не умножение. У неё
 *    f(0)=0 и f(1)=1 при любом g, то есть чёрное остаётся чёрным, а белое —
 *    белым: поднимается середина. Простое умножение выбивает лоб в бумагу
 *    ровно там, где мы только что сняли блик, и вся работа `deshine`
 *    обнуляется.
 * 2. ТОН — сдвиг R/B с ВОЗВРАТОМ ЯРКОСТИ. Без возврата «теплее» читается как
 *    «светлее», человек компенсирует это светом, и два ползунка начинают
 *    драться. Здесь тон меняет только цвет.
 *
 * Работает в ЛИНЕЙНОМ пространстве (плоскости движка), на месте — вызывающий
 * уже владеет копией после smoothSkin.
 */
(function (root) {
    'use strict';

    /**
     * @param {object} pl    плоскости {w,h,R,G,B} в линейном свете, меняются НА МЕСТЕ
     * @param {object} model результат analyze/rescaleModel — нужна только .mask;
     *                       null или неудачный разбор = работать по ВСЕМУ кадру
     * @param {object} p     {exposure:-1..1, warmth:-1..1, whole:boolean}
     *                       whole=true — работать по всему кадру, когда маски
     *                       нет; без него отсутствие маски = ничего не делать
     */
    function apply(pl, model, p) {
        p = p || {};
        var exposure = +p.exposure || 0;
        var warmth = +p.warmth || 0;
        if (exposure === 0 && warmth === 0) return pl;

        var n = pl.w * pl.h;
        // Маски может не быть вовсе — это лейн «лицо не найдено»: свет и тон
        // единственные две правки, которым геометрия не нужна в принципе, и
        // отказывать в них снимку без лица значило бы оставлять человека с
        // мёртвой страницей ради чистоты абстракции.
        //
        // ⚠️ Но работа по ВСЕМУ кадру объявляется вызывающим явно (`whole`), а
        // не выводится из «маски нет». У видео тот же вызов идёт покадрово с
        // моделью, и кадр, на котором лицо потерялось, молча получил бы правку
        // целиком — включая пересвеченное окно за спиной, ради которого этот
        // модуль и ограничен кожей.
        var mask = (model && model.ok && model.mask) ? model.mask : null;
        if (!mask && !p.whole) return pl;
        var R = pl.R, G = pl.G, B = pl.B;

        // ±0.75 ступени экспозиции на краях ползунка. Больше — уже не «ровный
        // свет», а перекрашивание: замерено на портретах корпуса, при 1.5
        // ступени тени под подбородком уходят в плоское серое.
        var g = exposure ? Math.pow(2, exposure * 0.75) : 1;
        var gm1 = g - 1;
        // 16% по красному и синему в разные стороны — примерно ±350 K на коже.
        var kr = 1 + warmth * 0.16;
        var kb = 1 - warmth * 0.16;

        for (var i = 0; i < n; i++) {
            var m = mask ? mask[i] : 1;
            if (m <= 0.002) continue;
            var r = R[i], gg = G[i], b = B[i];
            var nr = r, ng = gg, nb = b;

            if (exposure) {
                nr = g * nr / (1 + gm1 * nr);
                ng = g * ng / (1 + gm1 * ng);
                nb = g * nb / (1 + gm1 * nb);
            }
            if (warmth) {
                var l0 = 0.2126 * nr + 0.7152 * ng + 0.0722 * nb;
                var wr = nr * kr, wb = nb * kb;
                var l1 = 0.2126 * wr + 0.7152 * ng + 0.0722 * wb;
                var s = l1 > 1e-6 ? l0 / l1 : 1;
                nr = wr * s; ng = ng * s; nb = wb * s;
            }

            // Смешивание по маске: за её пределами кадр обязан остаться
            // байт-в-байт прежним, иначе на границе лица появляется ступенька.
            R[i] = r + (nr - r) * m;
            G[i] = gg + (ng - gg) * m;
            B[i] = b + (nb - b) * m;
            if (R[i] > 1) R[i] = 1; else if (R[i] < 0) R[i] = 0;
            if (G[i] > 1) G[i] = 1; else if (G[i] < 0) G[i] = 0;
            if (B[i] > 1) B[i] = 1; else if (B[i] < 0) B[i] = 0;
        }
        return pl;
    }

    root.FRTone = { apply: apply };
})(typeof window !== 'undefined' ? window : globalThis);
